<canvas class="" baseChart
   [labels]="barChartLabels"
   [options]="barChartOptions"
   [legend]="barChartLegend"
   [chartType]="barChartType"
   [datasets]="barChartData"
   >
 </canvas>
